export default function getApi(method, url) {
    return async function (params = {}) {
        try {
            let config = null;
            if (method.toLowerCase() === 'get') {
                config = { params };
            } else {
                config = {
                    data: JSON.stringify(params),
                    headers: {
                        'Content-Type': "application/json"
                    }
                };
            }
            let result = await this.axios(method, url, config);
            if (result)
                return result
        } catch (err) {
            throw err
        }
    };
}